import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_MANAGE_WORK_PACKAGES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function ProjectEditMenuItem({ project, openProjectEdit, ...props }) {
    if (project?.archived) return null

    return (
        <Secure demand={AUTHORING_MANAGE_WORK_PACKAGES_DEMAND} fallback={<Frag />}>
            <ContextMenuItem
                icon="mdi:pencil-outline"
                label="Edit"
                onClick={handleClick}
                data-cy="project-edit-menu-item"
                {...props}
            />
        </Secure>
    )

    function handleClick() {
        openProjectEdit(project)
    }
}
